<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headerau_note01" class="chapter" epub:type="frontmatter" id="au_note">
<header id="headerau_note01">
<h1 class="ctfm"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span><a class="xref" href="#/chisites0006#toc">Author’s Note</a></h1>
</header>
<p class="pf"><span class="page" data-locator="pvii"></span>Sun Ra and his colleagues in 1950s Chicago employed a great many terms to describe people who trace their ancestry to Africa: black, Black, BLACK, Black-Brown; Negroes, negroes, “Negroes,” so-called Negroes; Ethiopians, Ethiops, THE ETHIOPIAN RACES; and more. This proliferation of terms was intended to challenge conventional dismissals of the world’s “most-hated” people—a collective who, if it could “wake up” to its true nobility, might free itself and even the world. Playing with group names, and with capitalization and other typographic markers, became for Sun Ra an important way of multiplying the imagined capacities of his people.</p>
<p>Contemporary editorial preferences increasingly support capitalizing <i>Black</i> when referring to a person’s race or ethnicity. I welcome the discussions that have led to this shift and, were the book not already in press, would have adopted that practice. Beyond uppercasing or lowercasing the term, however, what remains significant is recognizing that racial and ethnic categories are social constructions with real meaning, and that exploring the collective history and identity of people of African descent is an ongoing project of enormous consequence. In the chapters that follow I have tried to respect Sun Ra’s own complex approach to language, including capitalization, which sought to subvert the racial terms of his era in order to give greater scope to creative conceptions of Black identity.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-sites-0007.vue?6974f063